import { MOUSEFLOW_VARIABLE } from "@/features/analytics/models";
import { setMouseflowSessionVariable } from "@/features/analytics/triggers";

const BMI_GROUP_THRESHOLD = 27;

export const trackBmiGroup = (bmi: number) => {
  setMouseflowSessionVariable({
    variable: MOUSEFLOW_VARIABLE.BMI_GROUP,
    value: bmi >= BMI_GROUP_THRESHOLD ? "27_plus" : "under_27",
  });
};

export const trackGender = (gender: string) => {
  setMouseflowSessionVariable({
    variable: MOUSEFLOW_VARIABLE.GENDER,
    value: gender,
  });
};

export const trackGlp1User = (isGlp1User: boolean) => {
  setMouseflowSessionVariable({
    variable: MOUSEFLOW_VARIABLE.GLP1_USER,
    value: isGlp1User ? "yes" : "no",
  });
};
